module.exports = __webpack_public_path__ + "static/media/aditya_verma.7a923b5f.png";